export default __webpack_public_path__ + "battery-with-plug.cc4f95f8656cc29df9844a3ca36d5882.svg";